import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import FileField from "../BaseControls/FileField/FileField";
import Manager from "lib/common/descriptorcontrols/FileField/manager";

export default class Label extends React.Component {
    render() {
        return (
            <ControlTemplate {...this.props} className="file-field" >
                <FileField {...this.props} readOnly />
            </ControlTemplate>
        );
    }
}

Label.propTypes = Manager.propTypes;



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/FileField/label.js